/* © CNES */
import OLTileLayer from 'ol/layer/Tile';
import { useContext, useEffect } from 'react';
import MapContext from '../MapContext';
/**
 * Tile Layer displayed on map.
 * @param source source of Tiles.
 * @param zIndex zIndex of the layer.
 * @returns null
 */
const TileLayer = ({ source, zIndex = 0 }: { source: any; zIndex: number }) => {
  const { map } = useContext(MapContext);
  /**
   * Display TileLayer on map.
   */
  useEffect(() => {
    if (!map) return;

    let tileLayer = new OLTileLayer({
      source,
    });
    map.addLayer(tileLayer);
    tileLayer.setZIndex(zIndex);
    return () => {
      if (map) {
        map.removeLayer(tileLayer);
      }
    };
  }, [map, source, zIndex]);
  return null;
};
export default TileLayer;
